import { Routes } from '@angular/router';

import { TrialAccountsComponent } from './containers/trial-accounts/trial-accounts.component';

export const TRIAL_ACCOUNTS_ROUTES: Routes = [
  {
    path: '',
    children: [{ path: '', component: TrialAccountsComponent }],
  },
];
